<template>
    <v-flex style="padding-bottom: 2em;">
        <v-row class="center">
            <v-col>
                <h2 class="card-title">Pre Registration</h2>
            </v-col>
        </v-row>
        <v-card style="margin: auto;" class="px-3 col-10 form-card">
            <v-stepper v-model="formStepper">
                <v-stepper-header>
                    <v-stepper-step complete-icon="fas fa-check" edit-icon="fas fa-check" :editable="formStepper >= 1"
                        :complete="formStepper >= 1" step="1">Company Info</v-stepper-step>
                    <v-stepper-step v-if="isEstablishment" complete-icon="fas fa-check" edit-icon="fas fa-check"
                        :editable="formStepper > 2" :complete="formStepper > 2" step="2">Search Terms</v-stepper-step>
                    <v-stepper-step v-else-if="acctType == 'Bartender' || acctType == 'Server'"
                        complete-icon="fas fa-check" edit-icon="fas fa-check" :editable="formStepper > 2"
                        :complete="formStepper > 2" step="2">Experience</v-stepper-step>
                    <v-stepper-step v-else complete-icon="fas fa-check" edit-icon="fas fa-check" :editable="formStepper > 2"
                        :complete="formStepper > 2" step="2">Events</v-stepper-step>
                    <v-stepper-step complete-icon="fas fa-check" edit-icon="fas fa-check" step="3">Add
                        Photos</v-stepper-step>
                </v-stepper-header>
                <v-stepper-content step="1">
                    <v-flex>
                        <v-form ref="businessRequiredForm" style="width: 100%; height: 100%;"
                            v-model="businessRequiredValidator" lazy-validation>
                            <v-row dense>
                                <v-col cols="6">
                                    <v-row dense>
                                        <v-icon style="margin: 0.5em 1em;">fas fa-store</v-icon>
                                        <h3 style="margin-top: 0.5em; margin-bottom: 0.5em;">Company Info</h3>
                                    </v-row>
                                    <v-divider></v-divider>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col class="center" sm="6" cols="12">
                                    <v-text-field color="#00006d" class="text-field-outline" v-model="partnerName"
                                        label="Company Name" outlined></v-text-field>
                                </v-col>
                                <v-col>
                                    <v-text-field color="#00006d" class="text-field-outline" v-model="website"
                                        label="Website (Optional)" prefix="https://" outlined></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col>
                                    <v-text-field color="#00006d" class="text-field-outline" :rules="emailStringRules"
                                        v-model="partnerEmail" prepend-inner-icon="fas fa-at"
                                        label="Company Email (Used to send account info)" outlined></v-text-field>
                                </v-col>
                                <v-col>
                                    <v-text-field color="#00006d" class="text-field-outline" v-model="slogan"
                                        label="Slogan (Optional)" outlined></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col>
                                    <v-text-field color="#00006d" v-model="contactNumber" v-mask="'(###) ###-####'"
                                        prepend-inner-icon="fas fa-phone" class="text-field-outline" ref="customer-phone"
                                        name="customer-phone" label="Phone Number" outlined></v-text-field>
                                </v-col>
                                <v-col>
                                    <v-row>
                                        <v-col style="padding: 0px;" sm="7" cols="6">
                                            <v-select outlined v-model="acctType" label="Account Type"
                                                color="#00006d" item-text="title" item-value="value" :items="availableAcctTypes"></v-select>
                                        </v-col>
                                        <v-col style="padding: 0px;" sm="2" cols="1">
                                            <site-button colorClasses="ml-2" btnType="text" :colNum="10" iconString="fas fa-clock"
                                                @click-event="hoursDialog = true" :toolTip="isContractor ? 'Set Availability' : 'Set Business Hours'"></site-button>
                                        </v-col>
                                        <v-col v-if="isEstablishment" style="padding: 0px;" sm="2" cols="1">
                                            <site-button :colorClasses="(rentable ? 'rentable-active' : 'rentable-inactive') + ' ml-2'" iconType="SVG" btnType="text" 
                                                :colNum="10" :iconString="rentableImage"
                                                @click-event="rentable = !rentable" :toolTip="rentable ? 'Not Rentable' : 'Available To Rent'"></site-button>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="8" md="6">
                                    <v-row>
                                        <v-icon style="margin: 0.5em 1em;">fas fa-user</v-icon>
                                        <h3 style="margin-top: 0.5em; margin-bottom: 0.5em;">User Info</h3>
                                    </v-row>
                                    <v-divider></v-divider>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="4" md="3">
                                    <v-text-field color="#00006d" v-model="contactFirstName" class="text-field-outline"
                                        ref="customer-first" name="customer-first" label="First Name"
                                        outlined></v-text-field>
                                </v-col>
                                <v-col cols="4" md="3">
                                    <v-text-field color="#00006d" ref="customer-last" name="customer-last"
                                        v-model="contactLastName" class="text-field-outline" label="Last Name"
                                        outlined></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="6">
                                    <v-row>
                                        <v-icon style="margin: 0.5em 1em;">fas fa-address-book</v-icon>
                                        <h3 style="margin-top: 0.5em; margin-bottom: 0.5em;">{{ isContractor ? 'Billing Info (Used To Pay You)' : 'Location Info' }}</h3>
                                    </v-row>
                                    <v-divider></v-divider>
                                </v-col>
                            </v-row>
                            <v-row dense style="margin-bottom: .5em;">
                                <address-component :key="addressKey" v-model="businessAddress"></address-component>
                            </v-row>
                            <v-row v-if="isEstablishment" dense class="center" style="margin-bottom: 2.5%;">
                                <v-col cols="7">
                                    <h3 style="padding-bottom: .75em" class="vertical-whitespace">Capacity</h3>
                                    <v-range-slider dense show-ticks="always" thumb-label="always" :step="1" :min="0"
                                        :max="8" v-model="capacity">
                                        <template v-slot:thumb-label="item">
                                            <span>{{ capacityChoices[item.value] }}</span>
                                        </template>
                                    </v-range-slider>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-flex>
                </v-stepper-content>
                <v-stepper-content v-if="isEstablishment" step="2">
                    <v-row dense>
                        <v-col cols="6">
                            <v-row>
                                <v-icon style="margin: 0.5em 1em;">fas fa-magnifying-glass</v-icon>
                                <h3 style="margin-top: 0.5em; margin-bottom: 0.5em;">Search Terms</h3>
                            </v-row>
                            <v-divider></v-divider>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="6" class="vertical-whitespace">
                            <v-chip-group v-model="customerInterestTags" multiple column active-class="primary--text">
                                <v-chip v-for="tag in customerTags" :key="tag" :value="tag">{{ tag }}</v-chip>
                            </v-chip-group>
                        </v-col>
                    </v-row>
                    <search-tag-row :business-search-tags="businessSearchTags" @add-tag="addSearchString"
                        @delete-tag="deleteSearchString" />
                    <v-row>
                        <v-col style="padding: 0px; margin: 0px;" sm="6" cols="6">
                            <h3>Age Restrictions</h3>
                        </v-col>
                        <v-col style="padding: 0px; margin: 0px;" sm="6" cols="6">
                            <h3>Demo Group</h3>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6">
                            <v-container>
                                <v-row>
                                    <v-range-slider dense v-model="ageRestriction"></v-range-slider>
                                </v-row>
                                <v-row>
                                    <v-col sm="3" cols="3">
                                        <v-text-field dense v-model="ageRestriction[0]" hide-details single-line
                                            type="number" variant="outlined" density="compact" min="0"
                                            @change="$set(ageRestriction, 0, $event)"></v-text-field>
                                    </v-col>
                                    <v-spacer></v-spacer>
                                    <v-col sm="3" cols="3">
                                        <v-text-field dense v-model="ageRestriction[1]" hide-details single-line
                                            type="number" variant="outlined" density="compact" :min="ageRestriction[0]"
                                            @change="$set(ageRestriction, 1, $event)"></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-col>
                        <v-divider vertical></v-divider>
                        <v-col cols="6">
                            <v-container>
                                <v-row>
                                    <v-range-slider dense v-model="demoGroup"></v-range-slider>
                                </v-row>
                                <v-row>
                                    <v-col sm="3" cols="3">
                                        <v-text-field dense v-model="demoGroup[0]" hide-details single-line type="number"
                                            variant="outlined" density="compact" min="0"
                                            @change="$set(demoGroup, 0, $event)"></v-text-field>
                                    </v-col>
                                    <v-spacer></v-spacer>
                                    <v-col sm="3" cols="3">
                                        <v-text-field dense v-model="demoGroup[1]" hide-details single-line type="number"
                                            variant="outlined" density="compact" :min="demoGroup[0]"
                                            @change="$set(demoGroup, 1, $event)"></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-col>
                    </v-row>
                </v-stepper-content>
                <v-stepper-content v-else-if="acctType == 'Bartender' || acctType == 'Server'" step="2">
                    <v-row dense>
                        <v-col cols="6">
                            <v-row dense>
                                <v-icon style="margin: 0.5em 1em;">fas fa-user-tie</v-icon>
                                <h3 style="margin-top: 0.5em; margin-bottom: 0.5em;">Job Experience</h3>
                            </v-row>
                            <v-divider></v-divider>
                        </v-col>
                    </v-row>
                    <v-container v-for="(experience, index) in experienceList" :key="experience.id" dense>
                        <v-row dense>
                            <v-col sm="8" cols="10">
                                <v-text-field dense v-model="experience.companyName" outlined
                                    label="Company"></v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <site-button btnType="text" :colNum="9" @click-event="removeExperience(index)"
                                    toolTip="Remove Entry" toolTipClasses="delete-tooltip" colorClasses="secondary-icon dense-btn"
                                    iconString="fas fa-trash"></site-button>
                            </v-col>
                            <v-col sm="5" cols="6">
                                <v-text-field dense v-model="experience.years" type="number" min="1" outlined
                                    label="Years Experience"></v-text-field>
                            </v-col>
                            <v-col sm="5" cols="6">
                                <v-text-field dense v-model="experience.title" outlined label="Job Title"></v-text-field>
                            </v-col>
                            <v-col sm="8" cols="10">
                                <v-textarea dense v-model="experience.description" outlined
                                    label="Description"></v-textarea>
                            </v-col>
                        </v-row>
                        <v-divider></v-divider>
                    </v-container>
                    <v-row class="center">
                        <v-col cols="8">
                            <site-button v-if="experienceList.length < 5" btnType="text" :colNum="11"
                                @click-event="addExperience" colorClasses="mt-5 success-icon"
                                toolTipClasses="success-tooltip" toolTip="Add Experience"
                                iconString="far fa-plus-square"></site-button>
                        </v-col>
                    </v-row>
                    <search-tag-row label="Skill Tags" :business-search-tags="businessSearchTags" @add-tag="addSearchString"
                        @delete-tag="deleteSearchString" />
                </v-stepper-content>
                <v-stepper-content v-else step="2">
                    <search-tag-row label="Planner Tags" :business-search-tags="businessSearchTags"
                        @add-tag="addSearchString" @delete-tag="deleteSearchString" />
                </v-stepper-content>
                <v-stepper-content step="3">
                    <v-row>
                        <v-col cols="3">
                            <image-card type="CIRCLE" @remove-business-photo="removeBusinessPhoto" @add-photo="addLogo"
                                :photo="logo"></image-card>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="center" cols="9">
                            <v-row>
                                <image-card v-for="(photo, index) in businessPhotos"
                                    @remove-business-photo="removeBusinessPhoto" @update-photo="updateBusinessPhoto"
                                    :index="index" :photo="photo.photoData" :key="index"></image-card>
                                <image-card title="Add Image" @remove-business-photo="removeBusinessPhoto"
                                    @add-photo="addBusinessPhotos" :photo="addImagePlaceholder"></image-card>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-stepper-content>
            </v-stepper>
            <v-row v-if="formStepper === 3">
                <v-col class="center">
                    <v-btn @click="formStepper--" class="whitespace-margin" block>Back</v-btn>
                </v-col>
                <v-col class="center">
                    <v-btn @click="submitForm" class="whitespace-margin" block>Submit</v-btn>
                </v-col>
            </v-row>
            <v-row v-else>
                <v-col class="center">
                    <v-btn @click="formStepper--" class="whitespace-margin" block>Back</v-btn>
                </v-col>
                <v-col class="center">
                    <v-btn :disabled="!acctType" @click="formStepper++" class="whitespace-margin" block>
                        {{ !acctType ? 'Choose Account Type' : 'Continue' }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-card>
        <v-dialog style="overflow-y: hidden;" width="70%" height="85%" v-model="hoursDialog">
            <v-card class="dialog-card">
                <v-flex class="inner-card-flex">
                    <v-row class="end">
                        <v-btn @click="hoursDialog = false" icon>
                            <v-icon>fas fa-times</v-icon>
                        </v-btn>
                    </v-row>
                    <business-hours :variant="isEstablishment ? 'BUSINESS' : 'CONTRACTOR'" @update-hours="updateBusinessHours" :businessHours="hours"></business-hours>
                </v-flex>
            </v-card>
        </v-dialog>
    </v-flex>
</template>

<style lang="scss">
@import '../../styles/styles.scss';

.dense-btn {
    max-height: 40px;
}

.v-text-field__details {
    display: none;
}

.v-dialog {
    overflow-y: hidden !important;
    border-radius: 15px;
    height: 80% !important;
    max-width: 80%;
}

.dialog-card {
    height: 100%;
    overflow-y: hidden;
}

.inner-card-flex {
    height: 100%;
    overflow-y: auto;
    margin-left: 0;
    margin-right: 0;
}
</style>

<script>
import BusinessHours from '../../components/common/Business/BusinessHours';
import SiteButton from '../../components/common/SiteButton';
import BusinessAddress from '../../components/common/Business/BusinessAddress';
import ImageCard from '../../components/common/ImageCard';
import SearchTagRow from '../../components/common/TagSelect';
import * as utils from '../../utilities/utils';
import * as GeoHash from 'ngeohash';
import { mask } from 'vue-the-mask';
import CustomerTags from '../../assets/Entities/customerTags';
import AccountType from '../../assets/Enums/AccountType';
import PartnerTypeEnum from '../../assets/Enums/PartnerTypeEnum';
import { MongoMixins } from '../../mixins/mongo-mixins';
import FileType from '../../assets/Enums/FileType';
import GeoPrecision from '../../assets/Enums/GeoHashEnums';

export default {
    name: 'Register',
    directives: {
        mask,
    },
    components: {
        'address-component': BusinessAddress,
        'image-card': ImageCard,
        'site-button': SiteButton,
        'business-hours': BusinessHours,
        'search-tag-row': SearchTagRow
    },
    mixins: [MongoMixins],
    props: {
        acct: {
            type: String,
            default: ''
        }
    },
    data: () => ({
        hoursDialog: false,
        slogan: '',
        website: '',
        acctType: '',
        formStepper: 1,
        capacityChoices: [0, 100, 200, 350, 500, 750, 1000, 1500, 2000, 2500],
        businessRequiredValidator: false,
        searchTagValidator: false,
        rentable: false,
        addressKey: 0,
        partnerName: '',
        logoImage: null,
        partnerEmail: '',
        contactNumber: '',
        contactFirstName: '',
        contactLastName: '',
        partnerType: PartnerTypeEnum.LIMITED.number,
        hours: [
            { weekDay: 1, opens: '', closes: '' },
            { weekDay: 2, opens: '', closes: '' },
            { weekDay: 3, opens: '', closes: '' },
            { weekDay: 4, opens: '', closes: '' },
            { weekDay: 5, opens: '', closes: '' },
            { weekDay: 6, opens: '', closes: '' },
            { weekDay: 7, opens: '', closes: '' },
        ],
        experienceList: [{
            years: 1,
            title: '',
            companyName: '',
            description: ''
        }],
        customerInterestTags: [],
        businessSearchTags: [],
        businessPhotos: [],
        ageRestriction: [0, 100],
        demoGroup: [0, 100],
        capacity: [0, 1],
        businessAddress: {
            line1: null,
            line2: null,
            city: null,
            state: {
                abbreviation: '',
                name: '',
            },
            zipCode: null,
        },
        businessGeoPoint: {
            lat: 0,
            lng: 0,
        },
        customerTags: CustomerTags,
    }),
    created() {
        this.acctType = this.acct;
    },
    computed: {
        // Can be put into class eventually.
        customerDisplayTags() {
            return this.customerTags.map(s => s[0].toUpperCase() + s.substring(1))
        },
        availableAcctTypes() {
            return [
                { title: 'Bar', value: AccountType.Bar },
                { title: 'Restaurant', value: AccountType.Restaurant },
                { title: 'Promoter', value: AccountType.Promoter },
                { title: 'Event Coordinator', value: AccountType.EventCoordinator },
                { title: 'Bartender', value: AccountType.Bartender },
                { title: 'Server', value: AccountType.Server }
            ]
        },
        searchTagLength() {
            return this.businessSearchTags.length;
        },
        logo() {
            return this.logoImage ? this.logoImage.photoData : require('../../assets/Add-Logo.svg');
        },
        addImagePlaceholder() {
            return require('../../assets/Add-Image-Placeholder.svg');
        },
        rentableImage() {
            return require('../../assets/Rentable.svg');
        },
        phoneRules() {
            return [v => !!v || 'Phone is required']
        },
        emailStringRules() {
            return [
                v => !!v || 'Please enter an email address',
                v => utils.testEmailValidity(v) || 'Please enter a valid email address',
            ]
        },
        isEstablishment() {
            return this.acctType === AccountType.Bar ||
                this.acctType === AccountType.Restaurant;
        },
        isContractor() {
            return this.acctType === AccountType.Bartender ||
                this.acctType == AccountType.Server;
        }
    },
    methods: {
        removeExperience(index) {
            this.experienceList.splice(index, 1);
        },
        addExperience() {
            this.experienceList.push({
                id: this.experienceList.length,
                years: 1,
                title: '',
                companyName: '',
                description: ''
            });
        },
        getCapacity(val) {
            return this.capacityChoices[val]
        },
        updateBusinessHours(hours) {
            this.hours = hours;
        },
        initialRegData() {
            this.formStepper = 1
            this.businessRequiredValidator = false
            this.searchTagValidator = false
            this.logoImage = null
            this.partnerName = ''
            this.website = ''
            this.slogan = ''
            this.partnerEmail = ''
            this.contactNumber = ''
            this.contactFirstName = ''
            this.contactLastName = ''
            this.acctType = ''
            this.partnerType = PartnerTypeEnum.LIMITED.number
            this.experienceList = [];
            this.customerInterestTags = []
            this.businessSearchTags = []
            this.businessPhotos = []
            this.ageRestriction = [0, 100]
            this.demoGroup = [0, 100]
            this.capacity = [0, 1]
            this.capacityChoices = [0, 100, 200, 350, 500, 750, 1000, 1500, 2000, 2500]
            this.hours = [
                { weekDay: 1, opens: '', closes: '' },
                { weekDay: 2, opens: '', closes: '' },
                { weekDay: 3, opens: '', closes: '' },
                { weekDay: 4, opens: '', closes: '' },
                { weekDay: 5, opens: '', closes: '' },
                { weekDay: 6, opens: '', closes: '' },
                { weekDay: 7, opens: '', closes: '' },
            ]
            this.businessAddress = {
                line1: null,
                line2: null,
                city: null,
                state: {
                    abbreviation: '',
                    name: '',
                },
                zipCode: null,
            }
            this.businessGeoPoint = {
                lat: 0,
                lng: 0,
            }
            this.customerTags = CustomerTags
            this.addressKey++
        },
        removeBusinessPhoto(index) {
            this.businessPhotos.splice(index, 1)
        },
        addSearchString(searchString) {
            console.log('add search string')
            this.businessSearchTags.push(searchString.toString())
        },
        deleteSearchString(index) {
            console.log('delete at ' + index)
            this.businessSearchTags.splice(index, 1)
        },
        updateBusinessPhoto(updatePhotoObj) {
            console.log(updatePhotoObj.photoFile.name)
            const reader = new FileReader()
            reader.onload = event => {
                this.$set(this.businessPhotos, updatePhotoObj.photoIndex, {
                    photoData: event.target.result,
                    photoFile: updatePhotoObj.photoFile,
                    type: FileType.BUSINESS,
                })
            }
            reader.readAsDataURL(updatePhotoObj.photoData)
        },
        addBusinessPhotos(files) {
            if (this.businessPhotos.length + 1 < 10) {
                for (let i = 0; i < files.length; i++) {
                    const item = files[i]
                    const reader = new FileReader()

                    console.log('add photo: ' + item.name)
                    reader.onload = event => {
                        this.businessPhotos.push({
                            photoData: event.target.result,
                            photoFile: item,
                            type: FileType.BUSINESS,
                        })
                    }
                    reader.readAsDataURL(item)
                }
            } else {
                alert('maximum photos chosen')
            }
        },
        addLogo(files) {
            const item = files[0]
            const reader = new FileReader()

            console.log('logo ' + item.name)

            reader.onload = event => {
                this.logoImage = {
                    photoData: event.target.result,
                    photoFile: item,
                    type: FileType.LOGO,
                }
            }
            reader.readAsDataURL(item)
        },
        submitForm() {
            if (this.$refs.businessRequiredForm.validate()) {
                const data = JSON.parse(JSON.stringify(this.$data))

                // clean up unneeded vars before db insert.
                delete data.customerTags
                delete data.formStepper
                delete data.businessPhotos
                delete data.searchTagValidator
                delete data.businessRequiredValidator
                delete data.addressKey
                delete data.logoImage
                delete data.capacityChoices
                delete data.hoursDialog
                if (data.website) data.website = `https://${data.website}`

                this.generateBusinessLocationData(data.businessAddress)
                    .then(locationData => {
                        console.log(JSON.stringify(locationData))
                        data.businessGeoPoint = locationData.data.results[0].geometry.location
                        console.log('GEOHASH: ' + GeoHash.encode(data.businessGeoPoint.lat, data.businessGeoPoint.lng))
                        data.geoHashGroup = GeoHash.encode(
                            data.businessGeoPoint.lat,
                            data.businessGeoPoint.lng,
                            GeoPrecision.GroupPrecision
                        )
                        data.capacity = [this.capacityChoices[data.capacity[0]], this.capacityChoices[data.capacity[1]]];
                        if (data.acctType == AccountType.Bartender || data.acctType == AccountType.Server) {
                            data.acctType = 'Contractor';
                        }
                        this.submitCompanyInfo(data)
                            .then(companyData => {
                                console.log('COMPDATA', companyData);
                                console.log('photos ', this.businessPhotos);
                                this.submitPhotos(companyData.data.id, [...this.businessPhotos, this.logoImage])
                                this.$refs.businessRequiredForm.resetValidation()
                                this.initialRegData()
                                this.$store.dispatch(
                                    'SHOW_SNACKBAR',
                                    'Company Request Successful. We will contact the provided email with login info when business is verified.'
                                )
                            })
                            .catch(e => {
                                this.$refs.businessRequiredForm.resetValidation()
                                this.$store.dispatch(
                                    'SHOW_SNACKBAR',
                                    'Submit Company Info Error. If persists please contact support.'
                                )
                                console.log('submit error: ' + e)
                            })
                    })
                    .catch(e => {
                        this.$store.dispatch(
                            'SHOW_SNACKBAR',
                            'Submit Company Info Error. Could not resolve location data ensure address is correct.'
                        )
                        console.log('generate location data error: ' + e)
                    })
            } else {
                setTimeout(() => {
                    this.$refs.businessRequiredForm.resetValidation()
                }, 5000)
            }
        },
    },
}
</script>
